import React from "react";
import { reduxForm, reset } from "redux-form";
import { LiveSearch } from "../Form";
import { useDispatch } from "react-redux";

const AddVenueEnquiry = ({ addVenue, disableAdd }) => {
  const dispatch = useDispatch();
  return (
    <LiveSearch
      id="shortlist-search"
      formId={"venueSearch"}
      url={`${window.API}/shortlists/quick`}
      onSelect={result => {
        result.venues.forEach((venue) => {
          addVenue(venue.id)
        })
        dispatch(reset("venueSearch"));
      }}
      auth
      label="Add venues from shortlist"
      name="shortlist"
      placeholder="Search by shortlist name"
      fieldClassName="w-full"
      wrapperClassName="mb-2"
      noBottom
      white
      getText={item => item.name}
    />
  );
};

export default reduxForm({
  form: "venueSearch",
  forceUnregisterOnUnmount: true,
})(AddVenueEnquiry);
